module.exports = __webpack_public_path__ + "static/media/portfolio.2b900908.jpg";